// @flow
import * as React from 'react';
import NoFormSelect from 'esm-web-pro/components/forms/fields/NoFormSelect';
import { FormattedMessage, injectIntl, IntlShape } from 'react-intl';
import point14Messages from 'esm-web-pro/messages/points14Messages';


type Props = {
    PoPLayer12: Object,
    value: ?string,
    onChange: Function,
    sfpNumber: ?string,
    intl: IntlShape,
};

const PortSelect = (props: Props) => {
    const {
        PoPLayer12, value, onChange, intl: { formatMessage }, sfpNumber,
    } = props;

    const choices = {};
    let opticalPorts = [];
    if (PoPLayer12.optical_switch_ports) {
        opticalPorts = Object.values(PoPLayer12.optical_switch_ports)
            .filter((val) => val.sfp_port_number === sfpNumber);
    } else if (PoPLayer12.optical_odf_ports) {
        opticalPorts = Object.values(PoPLayer12.optical_odf_ports);
    }

    opticalPorts.forEach((port: Object) => {
        if (port.port) return;
        choices[port.sequence] = `${formatMessage(point14Messages.opticalport)} ${port.sequence}`;
    });

    return (
        <NoFormSelect
            label={(
                <FormattedMessage id="connect-port-odf-port-select" defaultMessage="Choose port" />
            )}
            choices={choices}
            value={value}
            onChange={onChange}
            required
        />
    );
};

export default injectIntl(PortSelect);
